import React from 'react';

/**
 * Card Skeleton Component
 * Displays a skeleton loader for lead cards during data fetching
 */
const CardSkeleton = () => {
  return (
    <div className="lead-card skeleton-card card-bg" style={{ height: '200px', marginBottom: '8px' }}>
      <div className="skeleton-header">
        <div className="skeleton-title" style={{ width: '70%', height: '16px', backgroundColor: '#e0e0e0', borderRadius: '4px' }}></div>
        <div
          className="skeleton-badge"
          style={{ width: '60px', height: '20px', backgroundColor: '#e0e0e0', borderRadius: '12px', marginTop: '8px' }}
        ></div>
      </div>

      <div className="skeleton-content" style={{ marginTop: '16px' }}>
        <div
          className="skeleton-line"
          style={{ width: '100%', height: '12px', backgroundColor: '#e0e0e0', borderRadius: '4px', marginBottom: '8px' }}
        ></div>
        <div
          className="skeleton-line"
          style={{ width: '90%', height: '12px', backgroundColor: '#e0e0e0', borderRadius: '4px', marginBottom: '8px' }}
        ></div>
        <div className="skeleton-line" style={{ width: '80%', height: '12px', backgroundColor: '#e0e0e0', borderRadius: '4px' }}></div>
      </div>

      <div
        className="skeleton-footer"
        style={{ marginTop: '16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
      >
        <div className="skeleton-avatar" style={{ width: '32px', height: '32px', backgroundColor: '#e0e0e0', borderRadius: '50%' }}></div>
        <div className="skeleton-date" style={{ width: '80px', height: '12px', backgroundColor: '#e0e0e0', borderRadius: '4px' }}></div>
      </div>

      <style jsx>{`
        .skeleton-card {
          padding: 16px;
          background: white;
          border-radius: 8px;
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
          animation: pulse 1.5s ease-in-out infinite;
        }

        @keyframes pulse {
          0%,
          100% {
            opacity: 1;
          }
          50% {
            opacity: 0.6;
          }
        }
      `}</style>
    </div>
  );
};

/**
 * Multiple Skeleton Cards Component
 * Displays multiple skeleton cards for initial loading state
 */
export const CardSkeletonList = ({ count = 2 }) => {
  return (
    <div className="skeleton-list">
      {Array.from({ length: count }).map((_, index) => (
        <CardSkeleton key={`skeleton-${index}`} />
      ))}
    </div>
  );
};

export default CardSkeleton;
